import { render, staticRenderFns } from "./FileHolder.vue?vue&type=template&id=5722ff6a&scoped=true"
import script from "./FileHolder.vue?vue&type=script&lang=js"
export * from "./FileHolder.vue?vue&type=script&lang=js"
import style0 from "./FileHolder.vue?vue&type=style&index=0&id=5722ff6a&prod&lang=scss"
import style1 from "./FileHolder.vue?vue&type=style&index=1&id=5722ff6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../sites/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722ff6a",
  null
  
)

export default component.exports